import React from "react"

import TwoColumnHeroWithImageRight, {
  CONTAINMENT_MODE,
} from "./_base/TwoColumnHeroWithImageRight"

import { ChildSelector } from "../helpers/ChildSelector"

import * as sectionImageRightTableStyles from "../styles/SectionImageRightTable.module.css"

export default function SectionImageRightTable(props) {
  const { content } = props

  const title = ChildSelector.select(
    content,
    `title`,
    ChildSelector.SELECTOR_TYPE.TEXT,
  )

  const textStack = content.childNodes
    .filter(node => node.classNames === "content")
    .map(t => t.innerHTML)

  return (
    <div
      className={`row ${props.className} ${sectionImageRightTableStyles.wrapper}`}
    >
      <TwoColumnHeroWithImageRight
        contentClass={sectionImageRightTableStyles.content}
        imageHolder={content}
        imageSelector={`media-asset`}
        imageClass={sectionImageRightTableStyles.backgroundImage}
        className={sectionImageRightTableStyles.wrapper}
        mode={CONTAINMENT_MODE.normal}
      >
        <div className={sectionImageRightTableStyles.contentWrapper}>
          <h1
            className={sectionImageRightTableStyles.title}
            dangerouslySetInnerHTML={{
              __html: title,
            }}
          />
          {textStack.map((t, idx) => (
            <p
              className={sectionImageRightTableStyles.main}
              key={idx}
              dangerouslySetInnerHTML={{ __html: t }}
            />
          ))}
          <div
            className={`row ${props.className} ${sectionImageRightTableStyles.table}`}
          >
            <div className={sectionImageRightTableStyles.tableContainer}>
              <table className={sectionImageRightTableStyles.table}>
                <tbody>
                  <tr>
                    <td className={sectionImageRightTableStyles.sideColumn}>
                      Arc + Pulse on Cubewise Cloud
                    </td>
                    <td className={sectionImageRightTableStyles.middleColumn}>
                      Accelerate IBM Planning Analytics model development and simplify IBM Planning Analytics system
                      management with tools designed by and for TM1
                      professionals.
                    </td>
                    <td
                      className={sectionImageRightTableStyles.learnMoreColumn}
                    >
                      <a href="https://code.cubewise.com/services/cubewise-cloud/">Learn More</a>
                    </td>
                  </tr>
                  <tr>
                    <td className={sectionImageRightTableStyles.sideColumn}>
                      Cubewise Atmosphere
                    </td>
                    <td className={sectionImageRightTableStyles.middleColumn}>
                      Enable seamless data, business process and security
                      integration with an ever-growing library of pre-built
                      automations.
                    </td>
                    <td
                      className={sectionImageRightTableStyles.learnMoreColumn}
                    >
                      <a href="https://code.cubewise.com/software/innovation-labs/atmosphere/">Learn More</a>
                    </td>
                  </tr>
                  <tr>
                    <td className={sectionImageRightTableStyles.sideColumn}>
                      Cubewise PowerConnect
                    </td>
                    <td className={sectionImageRightTableStyles.middleColumn}>
                      Data, metadata and security integration between Microsoft
                      Power BI and IBM Planning Analytics.
                    </td>
                    <td
                      className={sectionImageRightTableStyles.learnMoreColumn}
                    >
                      <a href="https://code.cubewise.com/software/products/powerconnect/">Learn More</a>
                    </td>
                  </tr>
                  <tr>
                    <td className={sectionImageRightTableStyles.sideColumn}>
                      Apliqo Cloud
                    </td>
                    <td className={sectionImageRightTableStyles.middleColumn}>
                      Pre-built planning, analysis and consolidation solutions,
                      hosted and managed with 24/7 support.
                    </td>
                    <td
                      className={sectionImageRightTableStyles.learnMoreColumn}
                    >
                     <a href="https://apliqo.com/">Learn More</a>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </TwoColumnHeroWithImageRight>
    </div>
  )
}
